import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "dash-panel" }
const _hoisted_2 = { class: "dash-panel-head" }
const _hoisted_3 = {
  class: "btn btn-sm btn-outline-secondary pc-filter-btn",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#filterLeadModal"
}
const _hoisted_4 = {
  key: 0,
  class: "pc-filter-count"
}
const _hoisted_5 = {
  key: 1,
  class: "dash-empty"
}
const _hoisted_6 = { class: "pc-chart" }
const _hoisted_7 = { class: "pc-legend" }
const _hoisted_8 = { class: "pc-label" }
const _hoisted_9 = { class: "pc-count" }
const _hoisted_10 = { class: "pc-share" }
const _hoisted_11 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-labelledby": "filterLeadModalTitle",
  "aria-hidden": "true"
}
const _hoisted_12 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_13 = { class: "modal-content" }
const _hoisted_14 = { class: "modal-body" }
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _cache[13] || (_cache[13] = _createElementVNode("div", null, [
          _createElementVNode("span", { class: "dash-eyebrow" }, "Suivi"),
          _createElementVNode("h3", { class: "dash-panel-title" }, "Colis par statut"),
          _createElementVNode("p", { class: "dash-panel-sub" }, "Répartition des colis selon les filtres")
        ], -1)),
        _createElementVNode("button", _hoisted_3, [
          _cache[11] || (_cache[11] = _createElementVNode("i", {
            class: "ph ph-funnel",
            "aria-hidden": "true"
          }, null, -1)),
          _cache[12] || (_cache[12] = _createTextVNode(" Filtres ", -1)),
          (_ctx.activeFilters)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.activeFilters), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isLoader && !_ctx.legend.length)
        ? (_openBlock(), _createBlock(_component_AppLoader, {
            key: 0,
            label: "Chargement des statuts…"
          }))
        : (!_ctx.total)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[14] || (_cache[14] = [
              _createElementVNode("i", {
                class: "ph ph-chart-donut",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("p", null, "Aucun colis pour ces filtres.", -1)
            ])))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["pc-body", { 'is-refreshing': _ctx.isLoader }])
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_apexchart, {
                  type: "donut",
                  height: "250",
                  options: _ctx.donutOptions,
                  series: _ctx.seriesNumbers
                }, null, 8, ["options", "series"])
              ]),
              _createElementVNode("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legend, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.label,
                    class: "pc-item"
                  }, [
                    _createElementVNode("span", {
                      class: "pc-dot",
                      style: _normalizeStyle({ background: item.color })
                    }, null, 4),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(item.label), 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.value.toLocaleString("fr-FR")), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.share) + "%", 1)
                  ]))
                }), 128))
              ])
            ], 2))
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h2", {
              class: "modal-title",
              id: "filterLeadModalTitle"
            }, [
              _createElementVNode("i", {
                class: "ph ph-funnel",
                "aria-hidden": "true"
              }),
              _createTextVNode(" Filtrer les colis ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("form", {
              class: "row g-3",
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_15, [
                _cache[15] || (_cache[15] = _createElementVNode("label", {
                  class: "form-label",
                  for: "pc-start"
                }, "Date de", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "pc-start",
                  type: "date",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchSDate) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.searchSDate]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[16] || (_cache[16] = _createElementVNode("label", {
                  class: "form-label",
                  for: "pc-end"
                }, "Date fin", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "pc-end",
                  type: "date",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchEDate) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.searchEDate]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[18] || (_cache[18] = _createElementVNode("label", {
                  class: "form-label",
                  for: "pc-type"
                }, "Type colis", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "pc-type",
                  class: "form-select",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.type) = $event))
                }, _cache[17] || (_cache[17] = [
                  _createStaticVNode("<option value=\"\" selected data-v-834bdfd8>Tous</option><option value=\"SIMPLE\" data-v-834bdfd8>Colis Simples</option><option value=\"STOCK\" data-v-834bdfd8>Colis Stock</option><option value=\"SUPPLIER\" data-v-834bdfd8>Colis DropShippers</option><option value=\"SIMPLE_STOCK\" data-v-834bdfd8>Colis Produits</option>", 5)
                ]), 512), [
                  [_vModelSelect, _ctx.type]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label" }, "Magasin", -1)),
                _createVNode(_component_v_select, {
                  label: "name",
                  options: _ctx.ClientList,
                  modelValue: _ctx.customer,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customer) = $event)),
                  placeholder: "Chercher un client",
                  onSearch: _ctx.onSearchClients
                }, null, 8, ["options", "modelValue", "onSearch"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label" }, "Zone", -1)),
                _createVNode(_component_v_select, {
                  label: "name",
                  options: _ctx.ZonesList,
                  modelValue: _ctx.zone,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.zone) = $event)),
                  placeholder: "Chercher une zone",
                  onSearch: _ctx.onSearchZones,
                  "onOption:selected": _ctx.FetchAgencyList
                }, null, 8, ["options", "modelValue", "onSearch", "onOption:selected"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label" }, "Agence", -1)),
                _createVNode(_component_v_select, {
                  label: "name",
                  options: _ctx.AgencyList,
                  modelValue: _ctx.agency_receiving,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.agency_receiving) = $event)),
                  placeholder: "Chercher une agence",
                  "onOption:selected": _ctx.FetchCitiesList
                }, null, 8, ["options", "modelValue", "onOption:selected"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "form-label" }, "Ville", -1)),
                _createVNode(_component_v_select, {
                  label: "name",
                  options: _ctx.CitiesList,
                  modelValue: _ctx.city,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.city) = $event)),
                  placeholder: "Chercher une ville"
                }, null, 8, ["options", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label" }, "Livreur", -1)),
                _createVNode(_component_v_select, {
                  label: "name",
                  options: _ctx.LivreurList,
                  modelValue: _ctx.livreur,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.livreur) = $event)),
                  placeholder: "Chercher un livreur",
                  onSearch: _ctx.onSearchDrivers
                }, null, 8, ["options", "modelValue", "onSearch"])
              ])
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.ResetAll && _ctx.ResetAll(...args))),
              class: "btn btn-outline-secondary"
            }, " Réinitialiser "),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.FilterData && _ctx.FilterData(...args))),
              class: "btn btn-primary",
              "data-bs-dismiss": "modal"
            }, " Appliquer ")
          ])
        ])
      ])
    ])
  ], 64))
}